import React from "react";

import { useTypedSelector } from "../../hooks.tsx";
import PromptPanel from "./PromptPanel.tsx";
import ResponsePrompt from "./ResponsePrompt.tsx";
import { getSelectedConversationExchanges } from "../../store/conversation.tsx";

interface ExchangeProps {
  exchangeId: string;
  lastExchangeRef?: (node: HTMLElement | null) => void;
  onPulseAnimation?: () => void;
  stopPulseAnimation?: () => void;
}

const ExchangePanel: React.FC<ExchangeProps> = ({
  exchangeId,
  lastExchangeRef,
  onPulseAnimation,
  stopPulseAnimation,
}) => {
  const exchange = useTypedSelector(
    (state) => getSelectedConversationExchanges(state)?.byId[exchangeId],
  );

  if (!exchange) return null;

  return (
    <div key={exchange.id} data-exchange-id={exchange.id} ref={lastExchangeRef}>
      {exchange.prompt && exchange.prompt.trim() !== "" && (
        <PromptPanel
          key={`user_${exchange.id}`}
          role="user"
          content={exchange.prompt}
          exchange_id={exchange.id}
        ></PromptPanel>
      )}
      <ResponsePrompt
        exchange={exchange}
        onPulseAnimation={onPulseAnimation}
        stopPulseAnimation={stopPulseAnimation}
      />
    </div>
  );
};

export default React.memo(ExchangePanel);
